import {defineStore} from 'pinia';
import { AxiosRequestConfig } from "axios";
import apiRequest from '@/util/api-request';

// ワークの教材ライセンス (教材種別 workType を持つ)
interface WorkLicenseData {
  academicSessionYear: number;
  subjectId: number;
  subjectName: string;
  subjectFieldId: number;
  subjectFieldName: string;
  workType: number;
  publisherName: string;
  textbookEdition: number;
  workName: string;
  academicYear: string;
  startDate: string;
  endDate: string;
  usedStatus: string;
  isActiveLicense: boolean;
}

// CBTの教材ライセンス
interface CbtWorkLicenseData {
  academicSessionYear: number;
  subjectId: number;
  subjectName: string;
  subjectFieldId: number;
  subjectFieldName: string;
  publisherName: string;
  textbookEdition: number;
  workName: string;
  academicYear: string;
  startDate: string;
  endDate: string;
  usedStatus: string;
  isActiveLicense: boolean;
}

interface WorkLicenseListData {
  activeLicense: WorkLicenseData[];
  allLicense: WorkLicenseData[];
}

interface CbtWorkLicenseListData {
  activeLicense: CbtWorkLicenseData[];
  allLicense: CbtWorkLicenseData[];
}

interface WorkLicenseList {
  school_name: string;
  work_license_list: WorkLicenseListData | null;
  cbt_work_license_list: CbtWorkLicenseListData | null;
}

const useWorkLicenseListStore = defineStore('workLicenseListStore', {
  // state
  state: (): WorkLicenseList => {
    return {
      school_name: "",
      work_license_list: null,
      cbt_work_license_list: null,
    }
  },
  // getters
  getters: {
    schoolName: (state) => {
      return state.school_name
    },
    workLicenseList: (state) => {
      return state.work_license_list
    },
    cbtWorkLicenseList: (state) => {
      return state.cbt_work_license_list
    }
  },
  // actions
  actions: {
    async fetchListWorkLicense() {
      const config: AxiosRequestConfig = {
        method: "get",
        url: "/teacher/api/work_license/",
        headers: {
          "Content-Type": "application/json",
        }
      };
      const workLicenseData = await apiRequest(config);
      this.school_name = workLicenseData.data.schoolName
      this.work_license_list = workLicenseData.data.workLicenseList
      this.cbt_work_license_list = workLicenseData.data.cbtWorkLicenseList
    },
  }
})

export {useWorkLicenseListStore, WorkLicenseListData}